import { FirestoreOfflineDocument } from "@/core/modules/firestore/objects/FirestoreOfflineDocument";
import { OfflineModuleModel } from "./OfflineModuleModel";

export const offlineModuleModels: OfflineModuleModel<FirestoreOfflineDocument>[] = [];
